exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text][data-v-9efba7c0]{font-size:16px}.task-title.field-value[data-v-9efba7c0]{padding-top:21px;padding-left:20px}input[type=text].form-control.title-field[data-v-9efba7c0]{font-size:16px}", ""]);

// exports
